import { render, staticRenderFns } from "./transportationInformation.vue?vue&type=template&id=39acdcb0&scoped=true"
import script from "./transportationInformation.vue?vue&type=script&lang=js"
export * from "./transportationInformation.vue?vue&type=script&lang=js"
import style0 from "./transportationInformation.vue?vue&type=style&index=0&id=39acdcb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39acdcb0",
  null
  
)

export default component.exports